import Card from '../Card/Card'
import styles from './ApiError.module.css'
import imgErro from '../../assets/img/icone-erro.png';
import Message from '../Message/Message';
import BrButton from '@govbr/react-components/lib/BrButton';
import * as mensagens from '../../common/Mensagens';
import { useHistory } from 'react-router-dom';
import configuration from '../../envConfig';

type ApiConnectionErrorProps = {
  refreshOnClick?: boolean;
  onClose?: () => void
}

const ApiConnectionError = ({refreshOnClick = false, onClose}: ApiConnectionErrorProps) => {
  const history = useHistory()
  const handleClick = () => {
    history.replace("/home")
    if(onClose) {
      onClose()
    }
    if(refreshOnClick) {
      if (configuration.isCordova) {
        window.location.replace(window.location.href);
      } else {
        window.location.reload()
      }
    }
  }
  
  return (
    <>
      <Card className={styles.card}>
        <div className={styles.containerMensagem}>
          <img className={styles.imgMessage} src={imgErro} alt="Imagem" />
          <Message type={'error'} text={mensagens.MSG_ERRO_COMUNICACAO_API} />
          <div className={styles.botaoContainer}>
            <BrButton onClick={handleClick} className={styles.botao}>
              OK
            </BrButton>
          </div>
        </div>
      </Card>
    </>
  );
};

export default ApiConnectionError;
